// extracted by mini-css-extract-plugin
export default {"title":"nama-lengkap-pemilik-properti_title__tOuww"};